import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import JobManagement from './pages/JobManagement';
import JobDetail from './pages/JobDetail';
import AccountManagement from './pages/AccountManagement';
import CandidateManagement from './pages/CandidateManagement';
import TrainingManagement from './pages/TrainingManagement';
import TrainingDetail from './pages/TrainingDetail';
import NewsManagement from './pages/NewsManagement';
import BannerManager from './pages/BannerManager';

import NewsDetail from './pages/NewsDetail';
import CategoryManagement from './pages/CategoryManagement';
import CategoryDetail from './pages/CategoryDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/candidates" replace />} />
            <Route path="jobs" element={<JobManagement />} />
            <Route path="jobs/:id" element={<JobDetail />} />
            <Route path="accounts" element={<AccountManagement />} />
            <Route path="candidates" element={<CandidateManagement />} />
            <Route path="training" element={<TrainingManagement />} />
            <Route path="training/create" element={<TrainingDetail />} />
            <Route path="training/:id" element={<TrainingDetail />} />
            <Route path="news" element={<NewsManagement />} />
            <Route path="news/create" element={<NewsDetail />} />
            <Route path="news/:id" element={<NewsDetail />} />
            <Route path="categories" element={<CategoryManagement />} />
            <Route path="categories/create" element={<CategoryDetail />} />
            <Route path="categories/:id" element={<CategoryDetail />} />
            <Route path="banner" element={<BannerManager />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
